import React from 'react';
import PageLayout from './components/PageLayout';
import routes from '../../modules/routes/Routes';
import { Button } from 'react-daisyui';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useHardMatches } from '../../hooks/useHardMatches';

const OnboardingCompletion: React.FC = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { hardMatches } = useHardMatches();

    return (
        <PageLayout currentPage="Finish">
            <div className="mx-auto max-w-[500px] px-4">
                <div className="flex flex-col gap-4 my-8">
                    <h2 className="text-2xl font-bold mb-4">{t('pages.onboardingCompletion.congratulations')}</h2>
                    <div className="flex flex-col gap-2">
                        <p className="text-lg mb-6">
                            {t('pages.onboardingCompletion.profileSetupSuccess')}
                        </p>
                        <p className="mb-6">
                            {t('pages.onboardingCompletion.settingsChangeInfo')}
                        </p>
                        <p>
                            {t('pages.onboardingCompletion.nextSteps')}
                        </p>
                    </div>

                    <div className="flex flex-col gap-2 w-full">
                        <Button 
                            color="primary" 
                            onClick={() => navigate(routes.app.matches.build())} 
                            className="w-full"
                            data-umami-event="Onboarding Completed Show-matches"
                            loading={true}
                        >
                            {hardMatches.length > 0
                                ? t('pages.onboardingCompletion.showMatchesButton', { count: hardMatches.length })
                                : t('pages.onboardingCompletion.showEmptyMatchesButton')
                            }
                        </Button>
                    </div>
                </div>
            </div>
        </PageLayout>
    );
};

export default OnboardingCompletion;
